import { useQuery } from "@tanstack/react-query";
import AppSettingsService from "services/appSettingsService";

export const featureFlagQueryKeys = {
  byId: (featureId: string) => ["feature-flag", featureId] as const,
};

export const useFeatureFlag = (featureId: string, enabled = true) => {
  const query = useQuery({
    queryKey: featureFlagQueryKeys.byId(featureId),
    queryFn: () => AppSettingsService.getExperimentalFeature(featureId),
    enabled: enabled && featureId.trim().length > 0,
    staleTime: 5 * 60 * 1000,
  });

  return {
    ...query,
    feature: query.data ?? null,
    isEnabled: Boolean(query.data),
  };
};

